/**
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'com/ibm/vida/control/vida'
], function (_, vida) {
	'use strict';

	const hostAPI = {};

	/**
	 * This class is exposed as a glass service;  the CA Mobile App will use it to "warm up" VIDA
	 */
	class VidaResourceLoader {
		constructor(param) {
			void(param);
		}
		initialize(glassContext) {
			if ( this.done ) return Promise.resolve();
			this.done = true;
			try {
				return glassContext.findCollection('com.ibm.bi.dashboard.vipr.visLibrary').then(bundles => {
					_.extend(this, vida.VIPR.create({ bundles }));
					const bundleIds = bundles.map(bundle => bundle.id);
					const promises = [];
					bundleIds.forEach(id => promises.push(this._loadBundle(id)) );
					let loadPromise = this._delay();
					return Promise.all(promises).then(() => {
						bundleIds.forEach(id => {
							loadPromise = loadPromise.then(this._loadWidgetResources.bind(this, id));
						});
						return loadPromise;
					});
				});
			} catch ( err ) {
				console.debug(err);
				return Promise.resolve();
			}
		}

		_loadWidgetResources(id) {
			let widget;
			return this._delay().then(() => {
				widget = new vida.SmallMultipleGrid({ vipr: this, hostAPI }, id);
				return widget.newViz(id, 'client');
			}).then(() => {
				if ( widget && typeof widget.destroy === 'function' ) {
					return widget.destroy();
				}
			}).catch(console.debug);
		}

		_loadBundle(id) {
			return this.load(id).then(bundle => {
				return vida.SmallMultipleGrid.extendVizBundle(bundle);
			}).catch(console.debug);
		}

		_delay(time = 50) {
			return new Promise(resolve => setTimeout(resolve, time));
		}
	}
	return VidaResourceLoader;
});